<template>
  <form class="form-signin" novalidate  >
    <div v-show="editMode || step < 1" class="form-group">
      <label for="inputFeedUrl">Anbieter-Link</label>

      <input
        v-model="newFeed.url"
        @input="feedUrlChange"
        id="inputFeedUrl"
        class="form-control"
        placeholder="z.B. www.spiegel.de"
        type="url"
        required
        autofocus
      >
      <div class="invalid-feedback">{{this.invalidFeedbackForUrl}}</div>
    </div>
    <div v-if="step == 1 || step == 2" class="form-group">
      <div class="card">
        <div class="card-header">Wählen Sie einen Feed aus</div>
        <div v-if="step == 1" class="card-body text-center p-1">
          <i class="far fa-grin-stars fa-spin"></i>
        </div>
        <ul class="list-group list-group-flush">
          <button
            v-for="item in searchResult.feeds"
            v-bind:key="item.link"
            v-html="item.title"
            type="button"
            @click="selectedFeed(item.link)"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
          ><span class="badge badge-primary badge-pill">Auswählen</span>
          </button>
        </ul>
      </div>
    </div>
    <user-menu-button-bar
      v-if="!editMode && step < 2"
      ActionName="Suchen"
      v-on:executeAction="onSearchForFeeds"
      v-on:executeCancel="onExecuteCancel"
    />
    <user-menu-button-bar v-if="step == 2" v-on:executeCancel="onExecuteCancel"/>
    <div v-if="editMode || step==3" class="form-group">
      <label for="inputFeedName">Name</label>
      <input
        v-model="newFeed.name"
        @input="validateNameChanged"
        id="inputFeedName"
        class="form-control"
        placeholder="Name"
        required
      >
      <div class="invalid-feedback">{{this.invalidFeedbackForName}}</div>
    </div>
    <user-menu-select-category
      v-if="editMode || step==3"
      v-on:changed="onSelectedCategoryChanged"
      :init="newFeed.categoryId"
    />
    <user-menu-button-bar
      v-if="editMode || step==3"
      :ActionName="this.okButtonName"
      v-on:executeCancel="onExecuteCancel"
      v-on:executeAction="onExecuteAction"
    />
  </form>
</template>

<script>
import UserMenuButtonBar from "./User.Menu.ButtonBar.vue";
import UserMenuSelectCategory from "./User.Menu.SelectCategory.vue";
import axios from "axios";

export default {
  name: "User.Menu.AddForm",
  components: {
    UserMenuButtonBar,
    UserMenuSelectCategory
  },
  data: function() {
    return {
      newFeed: {
        url: "",
        name: "",
        category: "",
        categoryId: ""
      },
      invalidFeedbackForUrl: "1Geben Sie eine gültige URL an",
      invalidFeedbackForName: "Geben Sie einen Namen an",
      wasValidated: false,
      step: 0,
      searchResult: {
        version: 0,
        feeds: []
      }
    };
  },
  props: {
    callbackExecuteAction: Function,
    initFeed: Object,
    initStep: Number,
    okButtonName: String,
    formTitle: String,
    editMode: Boolean,
    
  },
  methods: {
    onSearchForFeeds: function() {
      this.searchResult.version = 0;
      this.searchResult.feeds = [];

      this.invalidFeedbackForUrl = "Geben Sie eine gültige URL an";
      let nameElement = document.getElementById("inputFeedUrl");
      nameElement.setCustomValidity("");

      if (!this.newFeed.url.includes("://"))
        this.newFeed.url = "https://" + this.newFeed.url;

      if (this.$el.checkValidity()) {
        this.step = 1;
        axios
          .get("https://indie42.de/dist/feedfinder.php?q=" + this.newFeed.url)
          .then(response => {
            if (response.data.version !== undefined)
              this.searchResult = response.data;
          })
          .catch(error => {
            console.log(error);
            this.invalidFeedbackForUrl = error;
          })
          .finally(() => {
            //Keine Feeds, dann lief etwas schief
            if (
              this.searchResult.feeds === undefined ||
              this.searchResult.feeds.length == 0
            ) {
              //Wenn eine Versionsnr vorhanden, dann hat die Seite keine Feeds
              if (this.searchResult.version > 0)
                this.invalidFeedbackForUrl = "Keine Feeds gefunden";
              nameElement.setCustomValidity(this.invalidFeedbackForUrl);
              this.$el.checkValidity();
              this.step = 0;
            } else this.step = 2;
          });
      }
      this.wasValidated = true;
      this.$el.classList.add("was-validated");
    },
    selectedFeed: function(aUrl) {
      this.newFeed.url = aUrl;
      this.feedUrlChange();
      this.step = 3;
    },
    onExecuteAction: function() {
      if (this.$el.checkValidity()) {
        this.callbackExecuteAction(this.newFeed);
        //this.$emit("executeCancel");
      }
      this.wasValidated = true;
      this.$el.classList.add("was-validated");
    },
    onExecuteCancel: function() {
      this.$emit("executeCancel");
    },
    onSelectedCategoryChanged: function(aCategory) {
      this.newFeed.category = aCategory.name;
      this.newFeed.categoryId = aCategory.id; // escape(aCategory.toLowerCase());
      this.validateNameChanged();
    },
    feedUrlChange: function() {
      try {
        this.invalidFeedbackForUrl = "Geben Sie eine gültige URL an";
        let nameElement = document.getElementById("inputFeedUrl");
        nameElement.setCustomValidity("");

        var url = new URL(this.newFeed.url);
        var parts = url.hostname.split(".");
        this.newFeed.name = parts[parts.length - 2];
      } catch {
        //console.log(err);
      }
    },
    validateNameChanged: function() {
      let category = this.$store.state.UserFeeds.items.find(
        item => item.id == this.newFeed.categoryId
      );

      if (category !== undefined) {
        let nameAlreadyExists = category.urls.find(
          feed => feed.name == this.newFeed.name
        );
        let nameElement = document.getElementById("inputFeedName");
        if (nameAlreadyExists !== undefined) {
          let errorText = "Der Name existiert in dieser Kategorie bereits";
          nameElement.setCustomValidity(errorText);
          this.invalidFeedbackForName = errorText;
        } else {
          nameElement.setCustomValidity("");
          this.invalidFeedbackForName = "Geben Sie einen Namen an";
        }

        if (this.wasValidated) this.$el.checkValidity();
      }
    }
  },
  created() {
    this.newFeed = this.initFeed;
    this.step = this.initStep;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-responsive {
  white-space: normal !important;
  word-wrap: break-word;
}

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}
.form-signin .checkbox {
  font-weight: 400;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
  margin-bottom: 10px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin select {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
